import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Report created", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Create report", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading. "))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.vchReportRecord)
          ? (_openBlock(), _createBlock(_component_app_button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openRecord'))),
              type: "gray",
              class: "mr-1 flex-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CheckCircleIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                _hoisted_2
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_app_button, {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('createRecord'))),
              type: "green",
              class: "mr-1 flex-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PlusIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                _hoisted_3
              ]),
              _: 1
            }))
      ], 64))
}